
import { BrandDetail, Branding } from "@/helper";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NavBar extends Vue {
  @Prop()
  public branding!: string;
  @Prop({ default: false })
  public isSplit!: boolean;

  public defaultBrand(): BrandDetail {
    if (Branding.isAccessBrandedFlow()) {
      return {
        id: "AccessCRM",
        logo: require("@/assets/AccessCRM.svg"),
      };
    }
    if (this.isSplit) {
      return Branding.brands.ProspectCRM;
    }
    // return the default white version of PS logo for the old version
    return {
      id: "ProspectCRM",
      logo: require("@/assets/prospect_logo_white.svg"),
    } as BrandDetail;
  }

  public get accessBrand() {
    return Branding.brands.AccessCRM;
  }
}
